"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _jsStorage = _interopRequireDefault(require("js-storage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useUserData = function useUserData(id, key, defaultValue) {
  var storage = (0, _react.useRef)(_jsStorage.default.localStorage).current;
  var userProfile = storage.get('user');
  var fullKey = (userProfile ? userProfile.id : 'anonymous') + "." + id + "." + key;
  var _useState = (0, _react.useState)(function () {
      if (storage.isSet(fullKey)) {
        return storage.get(fullKey);
      }
      return defaultValue;
    }),
    value = _useState[0],
    setValue = _useState[1];
  var setStoredValue = function setStoredValue(storedValue) {
    try {
      // allow value to be a function so we have same API as useState
      var valueToStore = typeof storedValue === 'function' ? storedValue(storedValue) : storedValue;
      storage.set(fullKey, valueToStore);
      setValue(valueToStore);
    } catch (e) {
      console.error(e);
    }
  };
  return [value, setStoredValue];
};
var _default = exports.default = useUserData;